module.exports = __webpack_public_path__ + "fonts/RMU-AvusPro-Italic.32326ec.woff2";